import { useMedia } from './useMedia';

export const useTouchDevice = () => {
  return useMedia('(any-hover: on-demand), (any-hover: none)');
};
